import { render, staticRenderFns } from "./crownBoundaryEventDropdown.vue?vue&type=template&id=59d91c2d&"
import script from "./crownBoundaryEventDropdown.vue?vue&type=script&lang=js&"
export * from "./crownBoundaryEventDropdown.vue?vue&type=script&lang=js&"
import style0 from "./crownDropdown.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports